var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVandlegeplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.476,8.03h-.2V6.268a.211.211,0,0,0-.21-.21H9.516a.21.21,0,0,0-.209.21V8.03H9.172a.21.21,0,0,0-.209.209V9.285a.21.21,0,0,0,.209.209h.219a1.523,1.523,0,0,1-3.019,0H6.65a.21.21,0,0,0,.209-.209V8.239A.21.21,0,0,0,6.65,8.03H6.385A4.4,4.4,0,0,0,2.658,3.92a.216.216,0,0,0-.167.049.21.21,0,0,0-.072.159V6.614a.211.211,0,0,0,.135.2A1.527,1.527,0,0,1,3.52,8.03H3.347a.21.21,0,0,0-.21.209V9.285a.21.21,0,0,0,.21.209h.174a4.365,4.365,0,0,0,8.722,0h.233a.21.21,0,0,0,.21-.209V8.239A.21.21,0,0,0,12.476,8.03ZM9.726,6.477h2.129V8H9.726ZM6.44,9.075H3.557V8.449H6.44Zm-3.6-2.6v-2.1A3.984,3.984,0,0,1,5.979,8.03H3.96A1.96,1.96,0,0,0,2.838,6.475Zm5.044,6.772A3.969,3.969,0,0,1,3.924,9.494H5.943a1.95,1.95,0,0,0,3.877,0h2.019A3.968,3.968,0,0,1,7.882,13.247Zm4.384-4.172H9.382V8.449h2.884Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.732,4.289a4.106,4.106,0,0,1,.317-.469,1.589,1.589,0,0,0,.417-.846.737.737,0,1,0-1.469,0,1.589,1.589,0,0,0,.417.846A4.25,4.25,0,0,1,10.732,4.289Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.736,5.239a4.282,4.282,0,0,1,.557.108,4.282,4.282,0,0,1-.108-.557,1.582,1.582,0,0,0-.3-.893A.77.77,0,0,0,8.8,3.851a.77.77,0,0,0,.046,1.085A1.582,1.582,0,0,0,9.736,5.239Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.225,5.347a4.315,4.315,0,0,1,.557-.108,1.579,1.579,0,0,0,.893-.3.77.77,0,0,0,.046-1.085.77.77,0,0,0-1.085.046,1.59,1.59,0,0,0-.3.893A4.282,4.282,0,0,1,11.225,5.347Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVandlegeplads);
export default __webpack_public_path__ + "static/media/VANDLEGEPLADS.a81eb64531d4bb426f59ec79c42c133e.svg";
export { ForwardRef as ReactComponent };